<div class="app-sidebar-div">
  <app-sidebar></app-sidebar>
</div>
<div class="page-content-outer">
  <router-outlet></router-outlet>
</div>
<button class="support-trigger">Need Help?</button>

<app-loader [isLoading]="anyStateLoading$ | async"></app-loader>
